<template>
  <div class="ticket-input">
    <div class="main-title">
      <span> <i class="el-icon-folder-opened"></i> 行程单录入 </span>
    </div>
    <div class="input-table">
      <table class="input-form" v-loading="loading">
        <thead>
          <th colspan="7">电子行程单填报表</th>
        </thead>
        <tbody>
          <tr>
            <td>行程描述</td>
            <td colspan="6">
              <el-input v-model="form.Remarks" placeholder="请输入行程描述"></el-input>
            </td>
          </tr>
          <tr>
            <td style="min-width: 120px">行程名称</td>
            <td>
              <el-select v-model="form.lineId" filterable placeholder="根据线路名搜索" @change="setRouteInfo">
                <el-option v-for="item in routes" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
              </el-select>
            </td>
            <td style="min-width: 120px">组团旅行社</td>
            <td>{{ CompanyName }}</td>
            <td style="min-width: 180px">行程时间</td>
            <td colspan="2" style="min-width: 555px">
              <el-date-picker
                v-model="form.StartTime"
                type="date"
                placeholder="请选择开始时间"
                :default-time="timeDefaultShow"
                @blur="dataChange(form.StartTime)"
              ></el-date-picker
              >至
              <el-date-picker v-model="form.EndTime" type="date" placeholder="结束时间" readonly></el-date-picker>
            </td>
          </tr>
          <tr>
            <td style="min-width: 120px">行程起点</td>
            <td colspan="2">
              <el-input v-model="form.StartPoint" placeholder="请输入行程起点"></el-input>
            </td>
            <td style="min-width: 120px">行程终点</td>
            <td colspan="3">
              <el-input v-model="form.EndPoint" placeholder="请输入行程终点"></el-input>
            </td>
          </tr>
          <tr>
            <td colspan="7" class="emphasis">行程安排</td>
          </tr>
          <tr style="height: 45px">
            <td colspan="7"></td>
          </tr>
          <div class="subtable-tab" v-if="tableVisible">
            <div
              v-for="(item, index) in table"
              :key="index"
              class="mouse-pointer tab-item"
              :class="{ 'sub-selected': currentSubId === item.id }"
              @click="handleSubtable('switch', item.id)"
            >
              <div>第{{ item.id + 1 }}天</div>
            </div>
            <div class="subtable-handle">
              <el-button-group>
                <el-button type="plain" @click="handleSubtable('plus')">＋</el-button>
                <el-button type="plain" @click="handleSubtable('minus')">﹣</el-button>
              </el-button-group>
              <!-- <i class="el-icon-plus mouse-pointer" @click="addSubTable"></i> -->
            </div>
          </div>
          <tr v-show="tableVisible">
            <td colspan="2">行程项目</td>
            <td colspan="2">行程时间</td>
            <td colspan="2">行程类型</td>
            <td>是否自费</td>
          </tr>
          <tr v-for="item in table[currentSubId].arrangement" :key="item.proId" v-show="tableVisible" v-loading="ProLoading">
            <td colspan="2">
              <el-select v-model="item.Id" placeholder="请选择" filterable>
                <el-option
                  v-for="pro in options.projects"
                  :key="pro.Id"
                  :label="pro.ProjectName"
                  :value="pro.Id"
                ></el-option>
              </el-select>
            </td>
            <td colspan="2">
              <el-time-picker
                is-range
                :clearable="false"
                v-model="item.Time"
                range-separator="至"
                format="HH:mm"
                value-format="HH:mm"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              ></el-time-picker>
            </td>
            <td colspan="2">
              {{ item.Id | getProjectType(options.projects) }}
            </td>
            <td>
              <el-checkbox v-model="item.IsSelf">自费</el-checkbox>
            </td>
          </tr>
          <!-- <tr v-show="tableVisible">
            <td colspan="2">备注行程（不列入统计）</td>
            <td colspan="5"><el-input v-model="form.RemarkTrip" placeholder="备注行程"></el-input></td>
          </tr> -->
          <tr v-show="tableVisible">
            <td colspan="7">
              <el-button-group>
                <el-button type="primary" size="mini" @click="handleArrangement('plus')">继续添加</el-button>
                <el-button type="danger" size="mini" @click="handleArrangement('minus')">删除行</el-button>
              </el-button-group>
            </td>
          </tr>
          <tr v-for="(item, index) in model.guides" :key="index + 999">
            <td>导游</td>
            <td>
              <el-select v-model="item.Id" clearable placeholder="请选择导游" filterable>
                <el-option
                  v-for="guide in GuidesOpitons"
                  :key="guide.Id"
                  :label="guide.Name"
                  :value="guide.Id"
                ></el-option>
              </el-select>
            </td>
            <td>导游证</td>
            <td>{{ item.Id | getGuideCode(listGuides) }}</td>
            <td>联系方式</td>
            <td style="min-width: 200px">
              {{ item.Id | getGuideTel(listGuides) }}
            </td>
            <td class="addItem">
              <el-button
                :icon="index == 0 ? 'el-icon-plus' : 'el-icon-minus'"
                @click="handleMultipleGuide(index, item.Id)"
              ></el-button>
            </td>
          </tr>
          
          <!-- 自备车添加 -->
          <tr style="height:45px;">
            <td>是否是自备车</td>
            <td colspan="2">
              <el-radio v-model="form.IsSelf" label="0" border>否</el-radio>
              <el-radio v-model="form.IsSelf" label="1" border>是</el-radio>
            </td>
            <td colspan="4" style="color:red;">如果是自备车,请选择'是'</td>
          </tr>
          <tr v-show="form.IsSelf==='0'" v-for="(item, index) in model.drivers" :key="index + 888">
            <td>司机</td>
            <td>
              <el-select v-model="item.Id" clearable filterable placeholder="请选择司机">
                <el-option
                  v-for="item in DriversOptions"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </td>
            <td>车牌号</td>
            <td>
              <el-select v-model="item.BusNumber" clearable filterable placeholder="请选择或模糊搜索" :filter-method="dataFilter">
                <el-option
                  v-for="item in listBuses"
                  :key="item.Id"
                  :label="item.PlateNumber"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </td>
            <td>联系方式</td>
            <td>{{ item.Id | getDriverTel(listDrivers) }}</td>
            <td class="addItem">
              <el-button
                :icon="index == 0 ? 'el-icon-plus' : 'el-icon-minus'"
                @click="handleMultipleDriver(index, item.Id)"
              ></el-button>
            </td>
          </tr>
          <tr v-show="form.IsSelf==='1'" v-for="(item,index) in form.newListSelf" :key="index+666">
            <td>司机</td>
            <td>
              <el-input placeholder="请输入司机姓名" v-model="item.selfDriverName"></el-input>
            </td>
            <td>车牌号</td>
            <td>
              <el-input placeholder="请输入车牌号" v-model="item.selfPlateNumber"></el-input>
            </td>
            <td>联系方式</td>
            <td>
              <el-input placeholder="请输入司机联系方式" v-model="item.selfDriverTel"></el-input>
            </td>
            <td class="addItem">
              <el-button
                :icon="index == 0 ? 'el-icon-plus' : 'el-icon-minus'"
                @click="handleSelfBus(index)"
              ></el-button>
            </td>
          </tr>
          <tr>
            <td :rowspan="visitors.length+1">游客信息</td>
            <td>游客姓名</td>
            <td>人数（人）</td>
            <td style="min-width: 100px">手机号</td>
            <td colspan="2">游客证件</td>
            <td>电子合同</td>
          </tr>
          <tr v-for="item in visitors" :key="item.Id">
            <td>
              <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                {{ visitor.Name }}
              </p>
            </td>
            <td>
              <p>{{ item.TotoalCount }}</p>
            </td>
            <td>
              <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                {{ (visitor.Tel=="" || visitor.Tel==null)?"无":visitor.Tel }}
              </p>
            </td>
            <td>
              <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                {{ visitor.CertificatesType }}
              </p>
            </td>
            <td>
              <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                {{ visitor.IDNumber }}
              </p>
            </td>
            <td>
              <i class="el-icon-s-order mouse-pointer" @click="openContract(item.Id)"></i>
            </td>
          </tr>

          <tr v-show="form.showNewTouristList===true" style="height: 55px"><td colspan="7">地接游客信息</td></tr>
        
          <tr v-show="form.showNewTouristList===true">
            <td>餐厅名称</td>
            <td colspan="3">
              <el-input v-model="form.RestaurantName" placeholder="请输入餐厅名称"></el-input>
            </td>
            <td>餐厅价格（元）</td>
            <td colspan="2">
              <el-input-number v-model="form.RestaurantPrice" :min="0" :precision="2"></el-input-number>
            </td>
          </tr>
          <tr v-show="form.showNewTouristList===true">
            <td>人数（人）</td>
            <td style="min-width: 120px">成人票（人）</td>
            <td>
              <el-input-number
                v-model="form.AdultCount"
                :min="0"
                @blur="AdultCountChange(form.AdultCount)"
                @input="AdultCountChange(form.AdultCount)"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">儿童票（人）</td>
            <td>
              <el-input-number
                v-model="form.ChildrenCount"
                :min="0"
                 @blur="ChildrenCountChange(form.ChildrenCount)"
                @input="ChildrenCountChange(form.ChildrenCount)"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">老年人票（人）</td>
            <td>
              <el-input-number
                v-model="form.ElderlyCount"
                 @blur="ElderlyCountChange(form.ElderlyCount)"
                @input="ElderlyCountChange(form.ElderlyCount)"
                :min="0"
              ></el-input-number>
            </td>
          </tr>
          <tr v-show="form.showNewTouristList===true">
            <td>价格（元）</td>
             <td style="min-width: 120px">成人价格（元）</td>
            <td>
              <el-input-number
                v-model="form.AdultPrice"
                :min="0"
                :precision="2"
                @input="AdultPriceChange"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">儿童价格（元）</td>
            <td>
              <el-input-number
                v-model="form.ChildrenPrice"
                :min="0"
                :precision="2"
                @input="ChildrenPriceChange"
              ></el-input-number>
            </td>
            <td style="min-width: 120px">老年人价格（元）</td>
            <td>
              <el-input-number
                v-model="form.ElderlyPrice"
                :min="0"
                :precision="2"
                @input="ElderlyPriceChange"
              ></el-input-number>
            </td>
          </tr>
          <tr v-show="form.showNewTouristList===true">
            <td colspan="2" style="min-width: 120px">同行总人数(含本人)</td>
            <td>
              <el-input-number v-model="form.TotoalCount" :min="0" disabled></el-input-number>
            </td>
            <td colspan="2" style="min-width: 120px">总价（元）</td>
            <td colspan="2">
              <el-input-number v-model="form.AllPrice" :min="0" :precision="2" disabled></el-input-number>
            </td>
          </tr>

          <tr v-show="form.showNewTouristList===true">
            <td :rowspan="form.newListTourist.length + 1">地接游客信息</td>
            <td>游客姓名</td>
            <td style="min-width: 130px">手机号</td>
            <td>证件类型</td>
            <td colspan="2">游客证件</td>
            <td>团队负责人</td>
          </tr>
          <tr v-show="form.showNewTouristList===true" v-for="(item, index) in form.newListTourist" :key="index + 1">
            <td>
              <el-input v-model="item.Name" placeholder="请输入游客姓名"></el-input>
            </td>
            <td>
              <el-input v-model="item.Tel" placeholder="请输入游客手机号"></el-input>
            </td>
            <td>
               <el-select v-model="item.CertificatesType" placeholder="请选择证件类型">
                <el-option
                  v-for="item in optionsType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
            <td colspan="2">
              <el-input v-model="item.IDNumber" placeholder="请输入游客证件"></el-input>
            </td>
            <td>
              <el-checkbox v-model="item.IsMain" @change="switchMainVisitor(item)">是</el-checkbox>
            </td>
          </tr>
        
        </tbody>
        <!-- </form> -->
      </table>

      <div style="text-align: center; padding-top: 40px;padding-bottom:80px;">
        <el-button type="success" size="mini" @click="submit('form')">保存</el-button>
        <el-button type="primary" size="mini" @click="reset('form')">重置</el-button>
        <el-button v-show="form.showNewTouristList===true" type="primary" size="mini" @click="handleVisitor('plus')">继续添加</el-button>
        <el-button v-show="form.showNewTouristList===true" type="danger" size="mini" @click="handleVisitor('minus')">删除行</el-button>
        <el-button type="info" size="mini"><a :href="'/api/co/Itineraries/DownloadTouristTemplant?sessionId='+sessionId"  
           style="color: white;">下载导入模板</a></el-button>
        <el-button type="warning" size="mini" @click="startExcel" >批量导入</el-button>
      </div>
      <!-- </form> -->

      <!-- 选择订单弹框 -->
      <el-dialog :visible.sync="orderDialog" title="选择订单" width="70%" :close-on-click-modal="false">
        <div style="overflow: auto; padding: 30px 0">
          <table class="input-form" >
            <tbody>
              <tr>
                <td>游客姓名</td>
                <td>人数（人）</td>
                <td style="min-width: 100px">手机号</td>
                <td colspan="2">游客证件</td>
                <td>是否勾选</td>
              </tr>
              <tr v-for="item in ordersDetail" :key="item.Id">
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.Name }}
                  </p>
                </td>
                <td>
                  <p>{{ item.TotoalCount }}</p>
                </td>
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ (visitor.Tel=="" || visitor.Tel==null)?"无":visitor.Tel }}
                  </p>
                </td>
                <td>
                   <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.CertificatesType }}
                  </p>
                </td>
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.IDNumber }}
                  </p>
                </td>
                <td>
                  <el-checkbox v-model="item.isSelected">是</el-checkbox>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="orderDialog = false">取 消</el-button>
          <el-button type="primary" @click="setVistors" :loading="LoadingTrue">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 下载合同弹框 -->
    <el-dialog :visible.sync="contractDialog">
      <contract-detail :orderId="orderId" v-if="contractDialog"></contract-detail>

      <div class="btn">
        <el-button @click="contractDialog = false"><a style="color: #000">取 消</a></el-button>
        <el-button v-if="contractInfo.ContactAttachment"
          ><a
            :href="'/api/co/Order/DownLoadOneDayContact?orderId=' + contractInfo.orderId + '&sessionId=' + sessionId"
            style="color: #000"
            >下载合同</a
          ></el-button
        >
      </div>
    </el-dialog>


    <!-- Excel导入弹框 -->
    <el-dialog title=""
              :visible.sync="excelInputDialog"
              v-loading="excelInputLoading"
              :close-on-click-modal="false"
              width="30%">
      <el-upload class="upload-drag"
                  drag
                  :limit="1"
                  :multiple="false"
                  ref="uploadExcelInput"
                  :auto-upload="false"
                  v-if="!excelInputLoading"
                  :with-credentials="true"
                  action=""
                  :http-request="uploadFile">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件，且不超过50MB</div>
      </el-upload>
      <span v-if="excelInputLoading">导入数据中，请等候...</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="excelInputDialog = false">取 消</el-button>
          <el-button type="primary" @click="$refs.uploadExcelInput.submit();">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import { getToken, getCookie } from '@/common/auth'
import ValidationProvider from '@/common/vee-validator'
import { ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import ContractDetail from '@/components/Contract.vue'
import Trip from '@/api/trip'
import Guide from '@/api/guide'
import Driver from '@/api/driver'
import Bus from '@/api/bus'
import Order from '@/api/order'
import Route from '@/api/route'
export default {
  name: 'TicketInput',
  data() {
    return {

      optionsType:[{
          value: '身份证',
          label: '身份证'
        }, {
          value: '港澳通行证',
          label: '港澳通行证'
        }, {
          value: '台湾通行证',
          label: '台湾通行证'
        },{
          value: '护照',
          label: '护照'
      }],

      LoadingTrue:false,
      contractInfo: {},
      sessionId: '',

      timeDefaultShow: '',
      start: '',
      // end: '',

      CompanyName: '',

      form: {
        lineId: '',
        CompanyId: '',
        StartTime: '',
        EndTime: '',
        TouristCount: 1,
        StartPoint: '',
        RemarkTrip:'',
        EndPoint: '',
        Remarks: '',
        GuideId: [],
        DriverId: [],
        BusId: [],
        AddNewItinerariesRoute: [], //形成项目信息

        //地接游客信息表
        newListTourist: [{ Name: '', Tel: '', IDNumber: '',CertificatesType:'身份证', IsMain: false }],
        showNewTouristList:false, //false:不显示   true:显示

        AdultCount:0,
        ChildrenCount:0,
        ElderlyCount:0,

        AdultPrice:0,
        ChildrenPrice:0,
        ElderlyPrice:0,

        RestaurantName:"",
        RestaurantPrice:0,

        TotoalCount:0,
        AllPrice:0,

        //是否是自备车  false:否  true:是  
        IsSelf:'0',

        // selfDriverName:"", //自备车司机姓名
        // selfPlateNumber:"", //自备车车牌号
        // selfDriverTel:"", //自备车司机联系方式

        //自备车信息
        newListSelf:[{selfDriverName:'',selfPlateNumber:'',selfDriverTel:''}],

      },
      loading: false,
      contractDialog: false,
      orderDialog: false,
      ordersOptions: [], //下拉选择订单
      ordersDetail: [], //订单详情
      orderSelected: [], //已选择订单
      model: {
        // EndTime: "",
        guides: [{ Id: '' }],
        drivers: [{ Id: '', BusNumber: '' }],
      },
      listGuides: [],
      GuidesOpitons: [],
      listDrivers: [],
      DriversOptions: [],
      listBuses: [],
      currentSubId: 0,
      tableVisible: false,
      orderId: '', //订单Id
      table: [
        {
          id: 0,
          arrangement: [],
        },
      ],
      routes: [],
      visitors: [
        {
          Id: '',
          TotoalCount: 0,
          AllTourist: [{ Id: '', Name: '', Tel: '', IDNumber: '',CertificatesType:'' }],
        },
      ],

      timerIndex: 1,
      startTime: '',

      linePointFlag: {
        flag: false,
        day: 0,
        point: 0,
      },

      excelInputDialog:false,
      excelInputLoading: false,
      ProLoading:false,

    }
  },
  filters: {
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type
        }
      }
      return ''
    },
    getGuideCode(value, guides) {
      for (const guide of guides) {
        if (guide.Id == value) {
          return guide.IDNumber
        }
      }
      return ''
    },
    getGuideTel(value, guides) {
      for (const guide of guides) {
        if (guide.Id == value) {
          return guide.Tel
        }
      }
      return ''
    },
    getDriverTel(value, drivers) {
      for (const driver of drivers) {
        if (driver.Id == value) {
          return driver.Tel
        }
      }
      return ''
    },
  },
  inject: ['deepClone', 'dateFormat'],
  watch: {
    'model.guides': {
      deep: true,
      handler: function(newVal, oldVal) {
        let _self = this
        _self.GuidesOpitons = JSON.parse(JSON.stringify(_self.listGuides))
        newVal.forEach((item) => {
          if (item.Id != '') {
            _self.GuidesOpitons.forEach((t, index) => {
              if (item.Id == t.Id) {
                _self.GuidesOpitons.splice(index, 1)
              }
            })
          }
        })
      },
    },
    'model.drivers': {
      deep: true,
      handler: function(newVal, oldVal) {
        let _self = this
        _self.DriversOptions = JSON.parse(JSON.stringify(_self.listDrivers))
        newVal.forEach((item) => {
          if (item.Id != '') {
            _self.DriversOptions.forEach((t, index) => {
              if (item.Id == t.Id) {
                _self.DriversOptions.splice(index, 1)
              }
            })
          }
        })
      },
    },

    table: {
      deep: true,
      handler: function(newVal, oldVal) {
        let _self = this
        let temp = ''
        _self.linePointFlag = {
          flag: false,
          day: 0,
          point: 0,
        }
        newVal.forEach((i, index) => {
          i.arrangement.forEach((c, count) => {
            if (count == 0) {
              temp = _self.getStr(c.Time[0].trim())
            }

            var vv = _self.getStr(c.Time[0].trim())
            if (parseInt(temp) <= parseInt(vv)) temp = vv
            else {
              _self.linePointFlag = {
                flag: true,
                day: index + 1,
                point: count + 1,
              }
              return
            }

            var vvv = _self.getStr(c.Time[1].trim())
            if (parseInt(temp) <= parseInt(vvv)) temp = vvv
            else {
              _self.linePointFlag = {
                flag: true,
                day: index + 1,
                point: count + 1,
              }
              return
            }
          })
        })
      },
    },
  },
  methods: {
    startExcel(){
      this.excelInputDialog=true;
    },
    //游客操作
    handleVisitor(type) {
      if (type === 'plus') {
        this.form.TotoalCount++;
        this.form.AdultCount++;
        this.form.newListTourist.push({
          Name: '',
          Tel: '',
          IDNumber: '',
          CertificatesType:'身份证',
          IsMain: false,
        })
      } else if (type === 'minus') {
        if (this.form.newListTourist.length > 1) {
          this.form.TotoalCount--;
          this.form.AdultCount--;
          this.form.newListTourist.pop();
        } else {
          this.$message.error('至少录入一位游客信息!');
        }
      }
    },
    uploadFile(item){
      var _self=this;

      if(_self.form.lineId=="" || _self.form.lineId==null){
         _self.$message.error("请先选择线路!");
         _self.excelInputDialog=false;
         return false;
      }

      const form = new FormData();
      form.append('touristFile', item.file);
      Order.exportTourist(form).then((res)=>{
        if(res.status=="success"){
          if(res.content!=null && res.content.length>0){
            _self.form.showNewTouristList=true;
            _self.form.TotoalCount+=res.content.length;
            _self.form.AdultCount+=res.content.length;
           
            if(_self.form.newListTourist[0].Name.trim()!="" && _self.form.newListTourist[0].IDNumber.trim()!=""){
               for(let i=0;i<res.content.length;i++){
                _self.form.newListTourist.push({
                  Name: res.content[i].Name,
                  Tel: res.content[i].Tel,
                  IDNumber: res.content[i].IDNumber,
                  CertificatesType: res.content[i].CertificatesType,
                  IsMain: (res.content[i].Main=='是' && _self.mainSelected==undefined) ?true:false,
                });

                if(res.content[i].Main=="是" && _self.mainSelected==undefined){
                  _self.mainSelected=true;
                }
              }
            }
            else{
              _self.form.newListTourist[0].Name=res.content[0].Name;
              _self.form.newListTourist[0].Tel=res.content[0].Tel;
              _self.form.newListTourist[0].IDNumber=res.content[0].IDNumber;
              _self.form.newListTourist[0].CertificatesType=res.content[0].CertificatesType;
              _self.form.newListTourist[0].IsMain=(res.content[0].Main=='是' && _self.mainSelected==undefined)?true:false;

              if(res.content[0].Main=="是" && _self.mainSelected==undefined){
                   _self.mainSelected=true;
              }

              for(let i=1;i<res.content.length;i++){
                _self.form.newListTourist.push({
                  Name: res.content[i].Name,
                  Tel: res.content[i].Tel,
                  IDNumber: res.content[i].IDNumber,
                  CertificatesType: res.content[i].CertificatesType,
                  IsMain: (res.content[i].Main=='是' && _self.mainSelected==undefined )?true:false,
                });
                if(res.content[i].Main=="是" && _self.mainSelected==undefined){
                  _self.mainSelected=true;
                }
              }
            }
          }
          _self.$message.success("导入成功!");
          _self.excelInputDialog=false;
          _self.$refs.uploadExcelInput.clearFiles();  //清空文件
        }
        else{
          _self.$message.error(res.msg);
        }
      });
    },


     //成人个数变化时
    AdultCountChange(val) {
      var _self = this;
      _self.form.AdultCount = parseInt(val);
      _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },
    ChildrenCountChange(val) {
      var _self = this;
      _self.form.ChildrenCount = parseInt(val);
    _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },
    ElderlyCountChange(val) {
      var _self = this;
      _self.form.ElderlyCount = parseInt(val);
     _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },

     //成人价格变化时
    AdultPriceChange(val) {
      var _self = this;
      _self.form.AdultPrice = parseFloat(val);
      _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },
    ChildrenPriceChange(val) {
      var _self = this;
      _self.form.ChildrenPrice = parseFloat(val);
    _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },
    ElderlyPriceChange(val) {
      var _self = this;
      _self.form.ElderlyPrice = parseFloat(val);
     _self.form.AllPrice =(parseInt(_self.form.AdultCount) * parseFloat(_self.form.AdultPrice)) + 
      (parseInt(_self.form.ChildrenCount) * parseFloat(_self.form.ChildrenPrice)) +
        (parseInt(_self.form.ElderlyCount) * parseFloat(_self.form.ElderlyPrice));
    },

    dataFilter(val){
      var _self=this;
      var param={PlateNumber:val}
      if(val.length>=2){
          Bus.listAllBuses(param).then((res)=>{
          if(res.status=="success"){
            _self.listBuses = res.content.filter((v) => v.Status === 0)
          }
          else{
            _self.$message.error(res.msg);
          }
        });
      }
    },
    getStr(str) {
      var aa = ''
      var bb = ''
      if (str.length == 4) {
        //8:00
        aa = str.substring(0, 1)
        bb = str.substring(str.length, 2)
      } else {
        //10:00
        aa = str.substring(0, 2)
        bb = str.substring(str.length - 2)
      }
      return aa + bb
    },

    //下拉改变数据源的值
    guideChange(Id) {},
    driverChange(Id) {
      var _self = this
      if (_self.listDrivers != null) {
        for (let i = 0; i < _self.listDrivers.length; i++) {
          if (Id == _self.listDrivers[i].Id) {
            _self.listDrivers.splice(i, 1)
          }
        }
      }
    },
    busChange(BusNumber) {
      var _self = this
      if (_self.listBuses != null) {
        for (let i = 0; i < _self.listBuses.length; i++) {
          if (BusNumber == _self.listBuses[i].Id) {
            _self.listBuses.splice(i, 1)
          }
        }
      }
    },

    //获取合同附件Id
    GetData(orderId) {
      var _self = this
      Order.getContractData({ Id: orderId }).then((res) => {
        if (res.status === 'success') {
          _self.contractInfo = res.content
        } else {
          _self.$message.error('合同获取失败!')
        }
      })
    },

    getProjectName(id) {
      for (const pro of this.options.projects) {
        if (pro.Id == id) {
          return pro.ProjectName
        }
      }
      return ''
    },
    openContract(orderId) {
      var _self = this
      if (orderId != '' && orderId != null && orderId != undefined) {
        _self.orderId = orderId
        _self.contractDialog = true

        _self.GetData(this.orderId)
      } else {
        _self.$message.error('未获取到订单信息!')
      }
    },
    //设置路线详情
    setRouteInfo(Id) {
      var _self = this;
      _self.ProLoading=false;
      Trip.getRouteDetail({ Id }).then((res) => {
        if (res.status === 'success') {
          _self.ProLoading=true;
          if (Array.isArray(res.content.dataAll)) {
            _self.tableVisible = true
            //项目
            _self.table = res.content.dataAll.map((v, i) => {
              return {
                id: i,
                arrangement: [
                  ...v.dataList.map((pro) => {
                    return {
                      Id: pro.PointId,
                      Name: pro.Projects,
                      Time: [
                        `${parseInt(pro.StartTime / 60)}:${(pro.StartTime % 60).toString().padStart(2, '0')}`,
                        `${parseInt(pro.EndTime / 60)}:${(pro.EndTime % 60).toString().padStart(2, '0')}`,
                      ],
                      IsSelf: false,
                    }
                  }),
                ],
              }
            })
            _self.timerIndex = _self.table[0].arrangement.length;
            if (_self.table != null && _self.table.length > 0 && _self.table != '') {
              _self.start = _self.table[0].arrangement[0].Time[0]; //第一天的开始时间
              _self.timeDefaultShow = _self.start + ':00';
              //最后一天的结束时间
              // _self.end =
              //   _self.table[_self.table.length - 1].arrangement[
              //     _self.table[_self.table.length - 1].arrangement.length - 1
              //   ].Time[1];
            }
          }

          if (res.content.dataCompany != null) {
            _self.CompanyName = res.content.dataCompany.Name
          }

          if (_self.form.StartTime != null && _self.form.StartTime != '' && _self.form.StartTime != undefined) {
            _self.dataChange(_self.form.StartTime)
          }

          if(res.content.lineMessage!=null){
            _self.form.AdultPrice=res.content.lineMessage.AdultPrice;
            _self.form.ChildrenPrice=res.content.lineMessage.ChildrenPrice;
            _self.form.ElderlyPrice=res.content.lineMessage.ElderlyPrice;

            _self.form.RestaurantName=res.content.lineMessage.RestaurantName;
            _self.form.RestaurantPrice=res.content.lineMessage.RestaurantPrice;
          }

          //游客
          // this.visitors = res.content.mainTourist;

          // if (Array.isArray(res.content.mainTourist)) {
          //   res.content.mainTourist.forEach((v) => {
          //     let visitor = [
          //       ...v.AllTourist.map((vi) => {
          //         return {
          //           id: vi.Id,
          //           name: vi.Name,
          //           tel: vi.Tel,
          //           idNumber: vi.IDNumber,
          //           orderId: v.Id,
          //           people: v.TotoalCount,
          //           contract: true,
          //         };
          //       }),
          //     ];
          //     this.visitors = [...this.visitors, ...visitor];
          //   });
          // }
        } else {
          _self.$message.error('线路行程安排获取失败');
        }
        _self.ProLoading=false;
      })
      //设置路线信息，设置model.startPoint  model.endPoint
      //根据路线中的CompanyId  发送请求得到CompanyId name 门店列表
    },
    //填充结束时间，选择订单添加游客
    dataChange(value) {
      let _self = this;
      _self.model={
        guides: [{ Id: '' }],
        drivers: [{ Id: '', BusNumber: '' }],
      };
      
      //确定结束时间
      _self.routes.forEach((v) => {
        if (v.Id === _self.form.lineId) {
          _self.form.EndTime = new Date(value).getTime() + (v.DayCount - 1) * 60 * 60 * 24 * 1000;
          var endtime="23:59";
          // var kk = _self.formatDate(_self.form.EndTime) + ' ' + _self.end;
          //结束时间都规定为当天时间得23分59秒
          var kk = _self.formatDate(_self.form.EndTime) + ' ' + endtime;
          _self.form.EndTime = kk;
          return
        }
      });
      var aa=_self.formatDate(new Date(value).getTime());
      var start_Time=aa+' '+_self.start;
      const { lineId, StartTime } = _self.form
      if (!lineId) {
        _self.$message.error('请先选择线路')
        return false
      }
      if (!StartTime) {
        _self.$message.error('请先选择行程开始时间')
        return false
      }
      if(_self.form.EndTime!="" && aa!=""){
        _self.loadAllDriversTime(start_Time,_self.form.EndTime);
        _self.loadAllGuidesTime(start_Time,_self.form.EndTime);
        _self.loadAllBusesTime(start_Time,_self.form.EndTime);
      }
      //获取订单，以供选择
      Trip.selectOrder({
        Id: lineId,
        StartTime,
        EndTime: this.dateFormat(this.form.EndTime),
      }).then((res) => {
        if (res.status === 'success') {
          if (res.content === null || res.content.length === 0) {
            _self.$message.error('所选日期没有订单')
            _self.visitors = [];
            _self.orderSelected = []
            return false
          }
          _self.ordersOptions = res.content.map((v) => {
            return {
              Id: v.Id,
              Name: v.Name,
            }
          })
          if (_self.ordersDetail.length == 0) {
            _self.ordersDetail = res.content
          } else {
            _self.ordersDetail = res.content
            _self.ordersDetail.forEach((item) => {
              _self.orderSelected.forEach((i) => {
                if (i == item.Id) {
                  _self.$set(item, 'isSelected', true)
                }
              })
            })

            _self.ordersDetail.forEach((item) => {
              if (item.isSelected == undefined || item.isSelected == null || item.isSelected == '') {
                _self.$set(item, 'isSelected', false)
              }
            })
          }
          // this.orderSelected = [];
          _self.orderDialog = true;
        } else {
          this.$message.error('订单获取失败')
        }
      })
    },
    //日期时间格式转换
    formatDate(time) {
      let date = new Date(time)
      let Y = date.getFullYear() + '-'
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D
    },
    //选择订单后填充游客信息
    setVistors() {
      var _self=this;
      _self.LoadingTrue=true;
      _self.visitors = []
      _self.orderSelected = []
      _self.ordersDetail.forEach((v) => {
        if (v.isSelected) {
          _self.LoadingTrue=false;
          if(!_self.LoadingTrue){
            _self.orderDialog = false;
            _self.visitors.push(v);
            _self.orderSelected.push(v.Id);
          }
        }
        else{
          _self.LoadingTrue=false;
          _self.orderDialog = false;
        }
      })
      // _self.orderDialog = false;
    },
    //子表操作
    handleSubtable(type, subId) {
      var _self = this
      switch (type) {
        case 'plus':
          _self.currentSubId = _self.table.length
          _self.table.push({
            id: _self.table.length,
            arrangement: [
              {
                Id: '',
                Time: ['08:00', '09:00'],
                IsSelf: false,
              },
            ], //time:[new Date()]
          })
          break
        case 'minus':
          if (_self.table.length > 1) {
            let index = 0
            _self.table.forEach((item, i) => {
              if (item.id == _self.currentSubId) {
                index = i
                _self.table.splice(i, 1)
              }
            })
            _self.table.forEach((item, i) => {
              item.id = i
            })
            if (index > 0) _self.currentSubId = _self.table[index - 1].id
            else _self.currentSubId = _self.table[index].id
            // this.currentSubId = this.table[index - 1].id;
          } else {
            _self.$message.error('至少录入一天行程!')
          }

          // if (_self.table.length > 1) {
          //   _self.table.pop()
          // } else {
          //   _self.$message.error('至少录入一天行程!')
          // }
          break
        case 'switch':
          _self.currentSubId = subId
          _self.timerIndex = this.table[subId].arrangement.length
          break
        default:
          break
      }
    },
    //行程安排操作
    handleArrangement(type) {
      var _self = this
      if (type === 'plus') {
        if (_self.linePointFlag.flag) {
          _self.$message.error(
            '第' + _self.linePointFlag.day + '天的第' + _self.linePointFlag.point + '个景点时间范围错误请修改'
          )
          return
        }

        if (
          _self.table[_self.currentSubId].arrangement[_self.table[_self.currentSubId].arrangement.length - 1].Time[1] ==
          '23:59'
        ) {
          _self.$message.error('当天行程已满无法继续添加!')
          return
        }

        if (_self.timerIndex >= 1)
          _self.startTime =
            _self.table[_self.currentSubId].arrangement[_self.table[_self.currentSubId].arrangement.length - 1].Time[1]
        _self.timerIndex++

        let endTime =
          parseInt(_self.startTime.substring(0, 2)) + 1 >= 24
            ? '23:59'
            : parseInt(_self.startTime.substring(0, 2)) + 1 >= 10
            ? parseInt(_self.startTime.substring(0, 2)) + 1 + ':00'
            : '0' + (parseInt(_self.startTime.substring(0, 2)) + 1) + ':00'

        _self.table[_self.currentSubId].arrangement.push({
          Id: '',
          // Time: ['08:00', '12:00'],
          Time: [_self.startTime, endTime],
          IsSelf: false,
        })
      } else if (type === 'minus') {
        if (_self.table[_self.currentSubId].arrangement.length > 1) {
          _self.timerIndex--

          _self.startTime =
            _self.table[_self.currentSubId].arrangement[_self.table[_self.currentSubId].arrangement.length - 1].Time[1]

          _self.table[_self.currentSubId].arrangement.pop()
        } else {
          _self.$message.error('至少录入一条行程!')
        }
      }
    },

    //提交
    submit(formName) {
      var _self=this;
      if (!_self.form.lineId) {
        _self.$message.error('行程名称不能为空!');
        return false;
      }
      if (!_self.form.StartTime || !_self.form.EndTime) {
        _self.$message.error('请输入行程时间!');
        return false;
      }
      if (!_self.form.StartPoint) {
        _self.$message.error('请输入行程起点!');
        return false;
      }
      if (!_self.form.EndPoint) {
        _self.$message.error('请输入行程终点!');
        return false;
      }
      if (!_self.form.BusId) {
        _self.$message.error('请补全车辆信息!');
        return false;
      }
      if (!_self.form.GuideId) {
        _self.$message.error('请补全导游信息!');
        return false;
      }
      if (!_self.form.DriverId) {
        _self.$message.error('请补全司机信息!');
        return false;
      }
     
      if(_self.form.showNewTouristList==true){
        if(_self.form.newListTourist.length==0){
          _self.$message.error('请录入地接游客信息!');
          return false;
        }

        if (_self.form.newListTourist.length > _self.form.TotoalCount) {
          _self.$message.error('游客信息数量大于同行总人数')
          return
        }

        let flag = false;
        _self.form.newListTourist.forEach((item)=>{
          if (
            item.Name == '' ||
            item.Name == undefined ||
            item.CertificatesType == '' ||
            item.CertificatesType == undefined ||
            item.IDNumber == '' ||
            item.IDNumber == undefined
          ) {
            _self.$message.error('游客信息未填写完整');
            flag = true;
            return false;
          }
        });

        if (flag) {
          return;
        }

        if (parseInt(_self.form.TotoalCount) != parseInt(_self.form.newListTourist.length)) {
          _self.$message.error('同行总人数与录入游客信息数量不符合!');
          return false;
        }
        if (_self.form.ElderlyCount + _self.form.ChildrenCount + _self.form.AdultCount != _self.form.TotoalCount) {
          _self.$message.error('票价人数错误!');
          return false;
        }

        if (!_self.mainSelected) {
          _self.$message.error('请选择一位团队负责人!');
          return false;
        }
        
      }
      else{
        if (_self.orderSelected.length === 0) {
          _self.$message.error('请选择订单!');
          return false;
        }
      }
      var aa=_self.formatDate(new Date(_self.form.StartTime).getTime());
      _self.form.StartTime=aa+' '+_self.start;

      _self.loading = true;
      //自动设置游客总数
      _self.form.TouristCount = _self.visitors.reduce((total, value) => total + value.TotoalCount, 0);
      // this.form.CompanyId = this.storeInfo.Id;
      _self.form.GuideId = _self.model.guides.map((v) => v.Id)
      _self.form.DriverId = _self.model.drivers.map((v) => v.Id)
      _self.form.BusId = _self.model.drivers.map((v) => v.BusNumber)

      _self.form.OrderId = _self.orderSelected
      //准备行程
      let arrangement = []
      _self.table.forEach((v) => {
        let day = { ListNewItinerariesRoute: [] }

        v.arrangement.forEach((a) => {
          day.ListNewItinerariesRoute.push({
            StartTime: a.Time[0],
            EndTime: a.Time[1],
            DayIndex: v.id + 1,
            Projects: _self.getProjectName(a.Id),
            PointId: a.Id,
            IsZiFei: a.IsSelf,
          })
        })
        arrangement.push(day)
      })
      _self.form.AddNewItinerariesRoute = arrangement

      Trip.addTrip(_self.form).then((res) => {
        if (res.status === 'success') {
          _self.$message.success('添加成功!');
          _self.reset();
        } else {
          _self.$message.error(res.msg);
        }
        _self.loading = false;
      });
    },
    //重置
    reset() {
      this.form = {
        lineId: '',
        CompanyId: '',
        StartTime: '',
        TouristCount: 1,
        StartPoint: '',
        EndPoint: '',
        Remarks: '',
        GuideId: [],
        DriverId: [],
        BusId: [],
        AddNewItinerariesRoute: [], //形成项目信息
        
        newListTourist: [{ Name: '', Tel: '', IDNumber: '',CertificatesType:'身份证', IsMain: false }],
        showNewTouristList:false,

        AdultCount:0,
        ChildrenCount:0,
        ElderlyCount:0,

        AdultPrice:0,
        ChildrenPrice:0,
        ElderlyPrice:0,

        RestaurantName:"",
        RestaurantPrice:0,

        TotoalCount:0,
        AllPrice:0,

        IsSelf:'0',
        newListSelf:[{selfDriverName:'',selfPlateNumber:'',selfDriverTel:''}],
      };
      this.model = {
        // EndTime: "",
        guides: [{ Id: '' }],
        drivers: [{ Id: '', BusNumber: '' }],
      };

      this.listGuides= [];
      this.GuidesOpitons= [];
      this.listDrivers= [];
      this.DriversOptions= [];
      this.listBuses= [];

      this.table = [
        {
          id: 0,
          arrangement: [],
        },
      ];
      this.visitors = [{ name: '', people: '', tel: '', idNumber: '',CertificatesType:'', contract: true }];
      this.form.showNewTouristList=false;
      this.LoadingTrue=false;
    },

    //导游
    handleMultipleGuide(index, Id) {
      var _self = this
      if (index == 0) {
        if (this.model.guides.length == this.listGuides.length) {
          this.$message.error('已无可用导游!')
          return
        }
        _self.model.guides.push({ Id: '' })
      } else {
        _self.model.guides.pop()
      }
    },
    handleMultipleDriver(index, driverId) {
      var _self = this;
      if (index == 0) {
        if (this.model.drivers.length == this.listDrivers.length) {
          this.$message.error('已无可用司机!');
          return;
        }
        _self.model.drivers.push({ Id: '', BusNumber: '' });
      } else {
        _self.model.drivers.pop();
      }
    },
    //添加自备车
    handleSelfBus(index){
      var _self=this;
      if(index==0){
        _self.form.newListSelf.push({selfDriverName:'',selfPlateNumber:'',selfDriverTel:''});
      }
      else{
        _self.form.newListSelf.pop();
      }
    },

    loadAllGuides() {
      Guide.listGuides().then((res) => {
        if (res.status === 'success') {
          this.listGuides = res.content.filter((v) => v.Status === 0)
          this.GuidesOpitons = JSON.parse(JSON.stringify(this.listGuides))
        } else {
          this.$message.error('导游获取失败!')
        }
      })
    },
    loadAllDrivers() {
      Driver.listDrivers().then((res) => {
        if (res.status === 'success') {
          this.listDrivers = res.content.filter((v) => v.Status === 0)
          this.DriversOptions = JSON.parse(JSON.stringify(this.listDrivers))
        } else {
          this.$message.error('司机获取失败!')
        }
      })
    },
    loadAllBuses() {
      Bus.listBuses().then((res) => {
        if (res.status === 'success') {
          this.listBuses = res.content.filter((v) => v.Status === 0)
        } else {
          this.$message.error('车辆获取失败!')
        }
      })
    },

    loadAllDriversTime(StartTime,EndTime) {
      var param={
        StartTime:StartTime,
        EndTime:EndTime,
      };
      Driver.listDriversByTime(param).then((res) => {
        if (res.status === 'success') {
          this.listDrivers = res.content.filter((v) => v.Status === 0)
          this.DriversOptions = JSON.parse(JSON.stringify(this.listDrivers))
        } else {
          this.$message.error('司机获取失败!')
        }
      })
    },
    loadAllGuidesTime(StartTime,EndTime) {
      var param={
        StartTime:StartTime,
        EndTime:EndTime,
      };
      Guide.listGuidesByTime(param).then((res) => {
        if (res.status === 'success') {
          this.listGuides = res.content.filter((v) => v.Status === 0)
          this.GuidesOpitons = JSON.parse(JSON.stringify(this.listGuides))
        } else {
          this.$message.error('导游获取失败!')
        }
      })
    },
    loadAllBusesTime(StartTime,EndTime) {
      var param={
        StartTime:StartTime,
        EndTime:EndTime,
      };
      Bus.listBusesByTime(param).then((res) => {
        if (res.status === 'success') {
          this.listBuses = res.content.filter((v) => v.Status === 0)
        } else {
          this.$message.error('车辆获取失败!')
        }
      })
    },
    //设置主要游客
    switchMainVisitor(item) {
      this.mainSelected = item.IsMain;
      if (!item || !item.Tel) {
        item.IsMain = false
        return false
      }
      this.form.newListTourist.forEach((v) => {
        if (v.Tel !== item.Tel) v.IsMain = false
      })
    },
  },

  //获取数据
  created() {
    // this.loadAllGuides()
    // this.loadAllDrivers()
    // this.loadAllBuses()

    //获取路线
    Route.getRoutes().then((res) => {
      if (res.status === 'success') {
        this.routes = res.content
      } else {
        this.$message.error('线路获取失败!')
      }
    })

    //获取已签合同的线路
    // Trip.getOrderRoutes().then((res) => {
    //   if (res.status === 'success') {
    //     this.routes = res.content
    //   } else {
    //     this.$message.error('线路获取失败!')
    //   }
    // })
  },
  mounted() {
    if (Array.isArray(this.routes) && this.routes.length > 0) {
      this.form.lineId = this.routes[0].Id
      this.setRouteInfo(this.form.lineId)
    }

    this.sessionId = getCookie('sessionId')
  },
  //获取仓库数据
  computed: {
    ...mapState('trip', {
      options: (state) => {
        return {
          projects: state.projects,
        }
      },
    }),
    ...mapState('user', ['storeInfo']),
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ContractDetail,
  },
}
</script>

<style scoped lang="less">
.main-title {
  width: 100%;
  justify-content: space-between;
  padding: 5px 10px;
  align-items: center;
  background: #efefef;
}
.input-table {
  padding: 20px;
}
.input-form {
  position: relative;
  width: 90%;
  min-width: 1220px;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    // width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}

.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}
.input-form /deep/ .el-date-editor .el-range-input,
.input-form /deep/ .el-date-editor .el-range-separator {
  margin: 4px;
}
.addItem /deep/ .el-button {
  width: 100%;
}
.sub-selected {
  background: cornflowerblue;
}
.subtable-tab {
  position: absolute;
  top: 190px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.emphasis {
  font-weight: bolder;
}
.subtable-tab .subtable-handle {
  min-width: 100px;
  border-right: 1px solid #aaa;
}
.subtable-tab /deep/ .el-button-group > .el-button {
  width: 50px;
  height: 45px;
  padding: 0;
  font-size: 18px;
  // border: none;
}
</style>
